let id = 0

export function uniqueId(): number {
  id++
  return id
}
